import { Config } from '@comall-backend-builder/core/lib/parser';
import { Entity } from '@comall-backend-builder/core/lib/parser';
export let config: Config = {
    entities: {
        // 页面展现
        presaleStock: {
            apiPath: '/pre_sales_products',
            properties: {
                // 表格表头的展现
                id: {
                    type: 'string',
                },
                sku: {
                    type: 'string',
                    displayName: 'SKU',
                },
                spu: {
                    type: 'string',
                    displayName: 'SPU',
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                },
                totalStock: {
                    type: 'number.row',
                    displayName: '预售总数量',
                },
                salesStock: {
                    type: 'number.integer',
                    displayName: '售出数量',
                },
                availableStock: {
                    type: 'number.integer',
                    displayName: '剩余预售数量',
                },
                preStartTime: {
                    type: 'string',
                    displayName: '预售开始时间',
                },
                preEndTime: {
                    type: 'string',
                    displayName: '预售结束时间',
                },
                preHotStartTime: {
                    type: 'string',
                    displayName: '预热开始时间',
                },
                preHotEndTime: {
                    type: 'string',
                    displayName: '预热结束时间',
                },
                styleCode: {
                    type: 'string',
                    displayName: '华夏款号',
                },
                imgUrl: {
                    type: 'string.image.text',
                    displayName: '商品图片',
                },
                preSendDay: {
                    type: 'string',
                    displayName: '发货时间',
                },
                preActivityNumber: {
                    type: 'string',
                    displayName: '预售活动编号',
                },
                saleStatus: {
                    type: 'string.options.select',
                    displayName: '上架状态',
                    options: [
                        {
                            id: 'NOT_SALES',
                            name: '下架',
                        },
                        {
                            id: 'SALES',
                            name: '上架',
                        },
                    ],
                },
            },
            filters: {
                // 页面上方的筛选项
                name: {
                    type: 'string',
                    displayName: '商品名称',
                    controlConfig: {
                        placeholder: '商品名称',
                    },
                },
                style_Code: {
                    type: 'string',
                    displayName: '款号',
                    controlConfig: {
                        placeholder: '款号',
                    },
                },
                sku: {
                    type: 'string',
                    displayName: 'SKU',
                    controlConfig: {
                        placeholder: 'SKU',
                    },
                },
                sale_status: {
                    type: 'string.options.select',
                    displayName: '上架状态',
                    options: [
                        {
                            id: 'SALES',
                            name: '上架',
                        },
                        {
                            id: 'NOTSALES',
                            name: '下架',
                        },
                    ],
                    multiple: true,
                },

                pre_start_time: {
                    type: 'string.dateTime',
                    displayName: '预售开始时间',
                },
                pre_end_time: {
                    type: 'string.dateTime',
                    displayName: '预售结束时间',
                },
                pre_activity_number: {
                    type: 'string',
                    displayName: '预售活动编号',
                },
            },
        },
    },
    components: {
        // 页面表格与路由挂载
        PresaleStockBatchBtns: {
            // 中间的一些下载操作
            component: 'FlexLayout',
            direction: 'horizontal',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'ProductInfoExportButton',
                    span: 3,
                    text: '预售库存导出',
                    type: 'primary',
                    source: {
                        apiPath: '/pre_sales_products/export',
                    },
                    flex: '0 0 auto',
                    style: {
                        marginRight: 16,
                        marginLeft: 12,
                    },
                    // entity: this.props.entity,
                },
            ],
        },
        PresaleStockView: {
            // 操作内容
            component: 'Card',
            entity: 'presaleStock',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    // 挂载顺序
                    {
                        component: 'PresaleStockFilter',
                    },
                    {
                        component: 'PresaleStockBatchBtns',
                    },
                    {
                        component: 'PresaleStockTable',
                    },
                ],
            },
        },
        PresaleStockTable: {
            // 表格上的所有
            component: 'DataTable',
            loadFirstPage: true,
            scroll: {
                x: true,
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '15', '20'],
            },
            columns: [
                {
                    property: 'styleCode',
                },
                {
                    property: 'imgUrl',
                    displayConfig: {
                        style: {
                            width: 104,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'sku',
                    modifiable: false,
                },
                {
                    property: 'name',
                    modifiable: false,
                },
                {
                    property: 'totalStock',
                    controlConfig: {
                        minConfig: 'salesStock',
                    },
                    modifiable: false,
                },
                {
                    property: 'salesStock',
                    modifiable: false,
                },
                {
                    property: 'availableStock',
                    modifiable: false,
                },
                {
                    property: 'preStartTime',
                    modifiable: false,
                },
                {
                    property: 'preEndTime',
                    modifiable: false,
                },
                {
                    property: 'preHotStartTime',
                    modifiable: false,
                },
                {
                    property: 'preHotEndTime',
                    modifiable: false,
                },
                {
                    property: 'preSendDay',
                },
                {
                    property: 'preActivityNumber',
                },
                {
                    property: 'saleStatus',
                },
            ],
        },
        PresaleStockFilter: {
            // 筛选
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'style_Code',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'sku',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'sale_status',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'pre_start_time',
                    controlConfig: {
                        style: { width: '100%' },
                    },
                },
                {
                    property: 'pre_end_time',
                    controlConfig: {
                        style: { width: '100%' },
                    },
                },
                {
                    property: 'pre_activity_number',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },
    },
    routes: [
        // 路由配置
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: 'presale-stock',
                            component: 'PresaleStockView',
                            breadcrumbName: '预售库存管理',
                        },
                    ],
                },
            ],
        },
    ],
};
